module.exports = __webpack_public_path__ + "static/media/MP.7e3550d7.svg";